export const optimizeGTMUrl = String(import.meta.env.VITE_OPTIMIZE_GTM_URL);
